export type SiteConfig = typeof siteConfig;

export const siteConfig = {
  name: "TanRabad Report",
  desc: "ทันระบาด รายงาน",
  pageItems: [
    {
      title: "จำนวนผู้ป่วย",
      key: "case"
    },
    {
      title: "ผลสำรวจลูกน้ำยุงลาย",
      key: "larval"
    },
    {
      title: "ผลสำรวจภาชนะขังน้ำ",
      key: "container"
    },
    {
      title: "ผลการปฏิบัติงาน",
      key: "execution"
    },
  ],
};
